// extracted by mini-css-extract-plugin
export var ClientStoriesListingWrapper = "ClientStoriesShortListing-module--ClientStoriesListingWrapper--+tkXl";
export var ClientStoriesListingGridItem = "ClientStoriesShortListing-module--ClientStoriesListingGridItem--KjFyq";